import { initializeApp } from 'firebase/app';
import { getAuth, setPersistence, browserSessionPersistence } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// Firebase configuration from environment variables
const firebaseSettings = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID
};

// Validate that all required Firebase config values are present
const requiredEnvVars = [
  'VITE_FIREBASE_API_KEY',
  'VITE_FIREBASE_AUTH_DOMAIN',
  'VITE_FIREBASE_PROJECT_ID',
  'VITE_FIREBASE_STORAGE_BUCKET',
  'VITE_FIREBASE_MESSAGING_SENDER_ID',
  'VITE_FIREBASE_APP_ID'
];

const missingEnvVars = requiredEnvVars.filter(
  varName => !import.meta.env[varName]
);

if (missingEnvVars.length > 0) {
  console.error('❌ Missing Firebase environment variables:', missingEnvVars);
  throw new Error(
    `Missing required Firebase configuration. Please check your .env file.\nMissing: ${missingEnvVars.join(', ')}`
  );
}

const firebaseApp = initializeApp(firebaseSettings);

export const auth = getAuth(firebaseApp);
export const db = getFirestore(firebaseApp);
export const storage = getStorage(firebaseApp);
export const firebaseAuth = auth; // Keep for backward compatibility
export const firestore = db; // Keep for backward compatibility

auth.languageCode = 'en';

// ═══ SESSION PERSISTENCE ═══
// Switch from LOCAL (survives browser restart forever) to SESSION (cleared on tab close)
setPersistence(auth, browserSessionPersistence)
  .catch((err) => console.error('⚠️ Failed to set auth persistence:', err));

// Session timeout configuration (in milliseconds)
// Users will be auto-logged out after this duration from login, regardless of activity
export const SESSION_TIMEOUT_MS = 60 * 60 * 1000; // 60 minutes
// Users will be auto-logged out after this duration of inactivity
export const INACTIVITY_TIMEOUT_MS = 30 * 60 * 1000; // 30 minutes

export default firebaseApp;